import 'angular:locale/data:zh-TW';
import 'angular:locale/data:pt-BR';
import 'angular:locale/data:he-IL';
import 'angular:locale/data:tr-TR';
import 'angular:locale/data:fr-CA';
import 'angular:locale/data:es-MX';
import 'angular:locale/data:en';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
